import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/protocol',
    name: 'protocol',
    component: () => import('../views/ProtocolView.vue'),
    meta: {
      title: '服务协议'
    }
  },
  {
    path: '/secret',
    name: 'secret',
    component: () => import('../views/SecretView.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/charge-protocol',
    name: 'charge-protocol',
    component: () => import('../views/ChargeProtocolView.vue'),
    meta: {
      title: '充值协议'
    }
  },
  {
    path: '/charge-safe',
    name: 'charge-safe',
    component: () => import('../views/ChargeSafeView.vue'),
    meta: {
      title: '充值安全提示'
    }
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/SupportView.vue'),
    meta: {
      title: '客服与反馈'
    }
  },
  {
    path: '/opus/:id',
    name: 'opus-share',
    component: () => import('../views/OpusShareView.vue'),
    meta: {
      title: '作品分享'
    }
  },
  {
    path: '/user/:uid',
    name: 'user-share',
    component: () => import('../views/UserShareView.vue'),
    meta: {
      title: '用户主页'
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component: () => import('../views/InviteRegisterView.vue'),
    meta: {
      title: '朋友分享人人有活'
    }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.afterEach(async (to) => {
  document.title = <string>to.meta.title || ''
})

export default router
